<template>
  <v-card tile v-if="employee !== null">
    <v-card-title
      >Dokumenti zaposlenega {{ employee.first_name }}
      {{ employee.last_name }}</v-card-title
    >
    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="documents.data"
        :page.sync="documents.current_page"
        :items-per-page="documents.per_page"
        :server-items-length="documents.total"
        :options.sync="tableOptions"
        :search="search"
        @update:options="loadEmployeeDocuments"
        :footer-props="{
          itemsPerPageOptions: [10, 25, 50],
        }"
        sort-by="id"
        class="elevation-1"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-text-field
              v-model="search"
              @change="loadEmployeeDocuments"
              append-icon="mdi-magnify"
              label="Iskalnik"
              single-line
              hide-details
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-btn color="primary" dark class="mb-2" @click="create"
              >Dodaj</v-btn
            >
          </v-toolbar>
        </template>
        <template v-slot:[`item.document_type_id`]="{ item }">
          {{ item.document_type.name }}
        </template>
        <template v-slot:[`item.valid_until`]="{ item }">
          {{
            item.valid_until !== null
              ? $moment(item.valid_until).format("DD.MM.YYYY")
              : null
          }}
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <TooltipIconButton
            tooltip="Uredi"
            icon="mdi-pencil"
            @click="
              $router.push({
                name: 'EmployeeDocument',
                params: { id: item.id },
              })
            "
          ></TooltipIconButton>
          <TooltipIconButton
            tooltip="Izbriši"
            icon="mdi-delete"
            @click="remove(item)"
          ></TooltipIconButton>
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="loadEmployeeDocuments">Reset</v-btn>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>
<script>
  import TooltipIconButton from "@/components/TooltipIconButton.vue";

  export default {
    data: () => ({
      dialog: false,
      headers: [
        {
          text: "ID",
          align: "start",
          value: "id",
        },
        { text: "Tip", value: "document_type_id" },
        { text: "Identifikator", value: "name" },
        { text: "Datum veljavnosti", value: "valid_until" },
        { text: "", value: "actions", sortable: false },
      ],
      employee: null,
      documents: {
        data: [],
      },
      documentTypes: [],
      editedIndex: -1,
      editedItem: {},
      tableOptions: {
        page: 1,
        itemsPerPage: 10,
      },
      search: "",
    }),
    mounted() {
      this.loadEmployee();
    },
    methods: {
      loadEmployee() {
        this.$http
          .get("api/v1/employees/" + this.$route.params.employeeId)
          .then((response) => {
            this.employee = response.data;
          })
          .catch(() => {
            this.$router.push({ name: "Employees" });
          });
      },
      async loadDocumentTypes() {
        await this.$http.get("api/v1/document-types").then((response) => {
          this.documentTypes = response.data;
        });
      },
      loadEmployeeDocuments() {
        let orderBy = {};
        if (
          this.tableOptions.sortBy.length > 0 &&
          this.tableOptions.sortDesc.length > 0
        ) {
          orderBy[this.tableOptions.sortBy[0]] =
            this.tableOptions.sortDesc[0] === true ? "desc" : "asc";
        }
        let params = {
          page: this.tableOptions.page,
          perPage: this.tableOptions.itemsPerPage,
          orderBy,
          filters: {},
        };

        if (this.search !== "") {
          params["filters"] = { name: encodeURI("%" + this.search + "%") };
        }

        params["filters"]["employee_id"] = this.$route.params.employeeId;

        this.$http
          .get("api/v1/employee-documents", { params })
          .then((response) => {
            this.documents = response.data;
          });
      },
      async create() {
        if (this.documentTypes.length === 0) {
          await this.loadDocumentTypes();
        }

        let inputOptions = {};
        for (let index = 0; index < this.documentTypes.length; index++) {
          const element = this.documentTypes[index];
          inputOptions[element.id] = element.name;
        }

        const { value } = await this.$swal({
          title: "Dodaj dokument",
          input: "select",
          inputOptions,
          inputPlaceholder: "Izberite tip dokumenta",
          showCancelButton: true,
          inputValidator: (value) => {
            return new Promise((resolve) => {
              if (value) {
                resolve();
              } else {
                resolve("Tip dokumenta je obvezen!");
              }
            });
          },
        });
        if (value === undefined) {
          return;
        }
        let documentTypeId = value;

        this.$swal({
          title: "Dodaj dokument",
          text: "Vpišite identifikator dokumenta",
          confirmButtonText: "Dodaj",
          cancelButtonText: "Prekliči",
          showCancelButton: true,
          input: "text",
        }).then((value) => {
          if (!value.value) {
            return;
          }
          this.$http
            .post("api/v1/employee-documents", {
              employee_id: this.$route.params.employeeId,
              document_type_id: documentTypeId,
              name: value.value,
            })
            .then((response) => {
              this.$router.push({
                name: "EmployeeDocument",
                params: {
                  employeeId: response.data.employee_id,
                  id: response.data.id,
                },
              });
            });
        });
      },
      remove(item) {
        this.$swal({
          title: "Pozor",
          text: "Ali ste prepričani da želite izbrisati dokument " + item.name,
          type: "warning",
          confirmButtonText: "Izbriši",
          cancelButtonText: "Prekliči",
          showCancelButton: true,
        }).then((value) => {
          if (value.value !== true) {
            return;
          }
          this.$http.delete("api/v1/employee-documents/" + item.id).then(() => {
            this.loadEmployeeDocuments();
          });
        });
      },
    },
    components: {
      TooltipIconButton,
    },
  };
</script>
<style></style>
